import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-premium";

import { Box, Typography, Button, Divider } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useAppTranslation } from "../../hooks/useAppTranslation";


type Props = {
  title: string;
  total: number;
  onAddVendor: () => void;
};

export default function VendorsToolbar({
  title,
  total,
  onAddVendor,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <GridToolbarContainer sx={{ px: 2, py: 1.5 }}>
      {/* LEFT */}
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="caption" color="text.secondary">
          {t("Łącznie")}: {total}
        </Typography>
      </Box>

      {/* RIGHT */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          size="small"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddVendor}
        >
          {t("Dodaj dostawcę")}
        </Button>

        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </Box>
    </GridToolbarContainer>
  );
}

